export default {
  COUNTRIES: [{
    "name": "Canada",
    "dial_code": "+1",
    "code": "CA"
  }, {
    "name": "United States",
    "dial_code": "+1",
    "code": "US"
  }, {
    "name": "Mexico",
    "dial_code": "+52",
    "code": "MX"
  }]
};